import {Api, HTTPMethod, buildExport} from "@next/apiconfig"
import env from "../../env"

const {REACT_APP_API_BASEURL, REACT_APP_ENTRYPOINT} = env

export class FooterApi implements Api {
    baseURL = `${REACT_APP_API_BASEURL}${REACT_APP_ENTRYPOINT}`
    version = "v1"
    endpoints = {
        getFooterData: {
            routeDefinition: "/footerdata/:footerName",
            getLocalURL: (footerName: string) => `/footerdata/${footerName}`,
            getRemoteURL: (footerName: string) => `/footers/${footerName}`,
            method: HTTPMethod.get,
        },
    }
}

const footerApi = new FooterApi()
export default (endpoint: keyof typeof footerApi.endpoints) => buildExport(footerApi, endpoint)
